import { render, staticRenderFns } from "./molecule.swatch.vue?vue&type=template&id=78f6f3a7&scoped=true"
import script from "./molecule.swatch.vue?vue&type=script&lang=ts"
export * from "./molecule.swatch.vue?vue&type=script&lang=ts"
import style0 from "./molecule.swatch.vue?vue&type=style&index=0&id=78f6f3a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f6f3a7",
  null
  
)

export default component.exports